<template>
    <div class="goods main-top-border">
        <div class="main-wrap">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="crumb">
                <el-breadcrumb-item :to="{ path: '/' }">买兰花</el-breadcrumb-item>
                <el-breadcrumb-item>选择分类</el-breadcrumb-item>
            </el-breadcrumb>
            <div v-show="allTypeList.length==0">暂无数据</div>
            <ul class="goods-list">
                <li v-for="(item,index) in allTypeList" :key="index">
                    <el-image class="img" :src="$common.imgPath(item.img)" :alt="item.img" lazy fit="cover"></el-image>
                    <div class=" desc-info">
                        <p class="title">{{item.typeName}} <span class="desc"><!--春兰如美人,不采羞自献。--></span></p>
                        <p class="flag" v-if="item.twoTypes.length!==0">
                            <span class="name" v-for="(v,subIndex) in item.twoTypes" :key="subIndex" @click="$router.push({'path':`/search/${item.id}/${item.typeName}/${v.id}/${v.typeName}`})">{{v.typeName}}</span>
                        </p>
                    </div>
                </li>
            </ul>
        </div>

    </div>

</template>

<script>
    import {getIndexTypeAll} from '../../api/goods'
    export default {
        data(){
            return {
                allTypeList:[],//全部分类列表
            }
        },
        created(){
            this.getIndexTypeAll();
        },
        methods:{
            getIndexTypeAll(){
                getIndexTypeAll().then(res=>{
                    this.allTypeList=res.data;
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '../../assets/css/common';
    .crumb{
        padding:15px 0 36px;
    }
    .goods-list{
        padding-bottom:36px;
        overflow: hidden;
        li{
            float: left;
            margin-bottom: 20px;
            width: 590px;
            /* height: 140px; */
            overflow: hidden;
            background-color: #F7F7F7;
            &:nth-child(2n){
                float: right;
            }
            display: table;
            .img{
                width:120px;
                height:120px;
                background-color:$main-color;
                overflow: hidden;
                text-align: center;
                display: table-cell;
                vertical-align: middle;
            }
            .desc-info{
                /*width:100%;*/
                /*!*padding:20px 0 0 20px;*!*/
                padding-left:20px;
                display: table-cell;
                vertical-align: middle;
                .title{
                    color: #000;
                    font-size: 20px;
                    padding-bottom: 10px;
                    font-weight: 600;
                    .desc{
                        font-size:14px;
                        color:#737373;
                    }
                }
                .flag{
                    color:#000;
                    font-size:14px;
                    line-height:30px;
                    .name{
                        &:hover{color:$assist-color;cursor: pointer;}
                        border-right:1px solid #000;padding:0 5px;}
                }
            }
        }
    }
</style>